import styles from "./Card.module.css";
import { FaPlus, FaCircle } from "react-icons/fa";
import classNames from "classnames";

const Card = ({
  state = "display", // "create", "loading", "display"
  onCreateClick,
  onSelectClick,
  isSelected = false,
  fullWidth = false,
  fullHeight = false,
  title,
  subtitle,
  children,
  upperChildren,
  lowerChildren,
  createText = "Add New",
  loadingText = "Creating...",
  className,
  ...props
}) => {
  const handleCreateClick = () => {
    if (onCreateClick && state === "create") {
      onCreateClick();
    }
  };

  const handleSelectClick = () => {
    if (onSelectClick && state === "display") {
      onSelectClick();
    }
  };

  const renderCreateState = () => (
    <button
      className={styles.CreateState}
      onClick={handleCreateClick}
      disabled={state === "loading"}
    >
      <div className={styles.AssetContentWrapper}>
        <div className={styles.CreateButton}>
          <FaPlus className={styles.CreateIcon} />
        </div>
      </div>
      <div className={styles.AssetInformationContainer}>
        <span className={styles.CreateText}>{createText}</span>
      </div>
    </button>
  );

  const renderLoadingState = () => (
    <div className={styles.LoadingState}>
      <div className={styles.AssetContentWrapper}>
        <div className={styles.LoadingSpinner}>
          <FaCircle className={styles.SpinnerIcon} />
        </div>
      </div>
      <div className={styles.AssetInformationContainer}>
        <span className={styles.LoadingText}>{loadingText}</span>
      </div>
    </div>
  );

  const renderDisplayState = () => (
    <div className={styles.DisplayState}>
      {upperChildren && (
        <div className={styles.UpperContent}>{upperChildren}</div>
      )}
      <div
        className={classNames(styles.AssetInformationContainer, {
          [styles.AssetInformationContainerFullWidth]: fullWidth,
          [styles.AssetInformationContainerFullHeight]: fullHeight,
        })}
      >
        {(title || subtitle) && (
          <div className={styles.Header}>
            {title && <h3 className={styles.Title}>{title}</h3>}
            {subtitle && <p className={styles.Subtitle}>{subtitle}</p>}
          </div>
        )}
        {(children || lowerChildren) && (
          <div className={styles.Content}>
            {children}
            {lowerChildren}
          </div>
        )}
      </div>
    </div>
  );

  const renderContent = () => {
    switch (state) {
      case "create":
        return renderCreateState();
      case "loading":
        return renderLoadingState();
      case "display":
        return renderDisplayState();
      default:
        return renderDisplayState();
    }
  };

  return (
    <div
      className={classNames(
        styles.Card,
        {
          [styles.CardCreate]: state === "create",
          [styles.CardLoading]: state === "loading",
          [styles.CardDisplay]: state === "display",
          [styles.CardSelected]: isSelected && state === "display",
          [styles.CardClickable]:
            (state === "display" && onSelectClick) ||
            (state === "create" && onCreateClick),
          [styles.CardFullWidth]: fullWidth,
          [styles.CardFullHeight]: fullHeight,
        },
        className,
      )}
      onClick={handleSelectClick}
      onKeyDown={handleSelectClick}
      {...props}
    >
      {renderContent()}
    </div>
  );
};

export default Card;
